import React from 'react';
import classes from './ErrorMessage.module.css';

const ErrorMessage = ({ children, style }) => {
  return (
    <div style={style} className={classes.errorContainer}>
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
        <path 
          fillRule="evenodd" 
          clipRule="evenodd" 
          d="M4.4452 5.5L0 1.0548L1.0548 0L5.5 4.4452L9.9452 0L11 1.0548L6.5548 5.5L11 9.9452L9.9452 11L5.5 6.5548L1.0548 11L0 9.9452L4.4452 5.5Z" 
          fill="#CB1541"
        />
      </svg>
      <span className={`${classes.error} slimRegularSmallText`}>{children}</span>
    </div>
  );
};

export default ErrorMessage;
